import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import { initializeAnalytics } from './services/analytics';

// Initialize analytics early
initializeAnalytics();

const rootElement = document.getElementById('root') as HTMLElement;

// Create a root
const root = ReactDOM.createRoot(rootElement);

// Render your app inside the root
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to measure performance, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
